import CostList from "@/cost/CostList";

export default [
    {
        path: '/costs',
        name: 'CostList',
        component: CostList
    },
];
